module.exports = __webpack_public_path__ + "static/img/6.73945a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/6.png
// module id = eEO5
// module chunks = 0